import { useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import _get from 'lodash/get';
import { getPercent } from '@/shared/utils/formatters';
import * as StatsIndicator from '@/shared/ui/StatsIndicator';
import { SharesChart } from '@/features/accountingAndAnonymous/Shares';

type WorkerSharesProps = {
  workerName: string;
  workerData: any;
  className?: string;
}

const WorkerShares = (props: WorkerSharesProps) => {
  const { 
    workerName,
    workerData = {},
    className, 
  } = props;
  const intl = useIntl();
  const [visibleChartBars, setVisibleChartBars] = useState([]);
  const validShares = String(_get(workerData, 'validCount', 0));
  const staleShares = String(_get(workerData, 'staleCount', 0));
  const invalidShares = String(_get(workerData, 'invalidCount', 0));
  const validRate = _get(workerData, 'validRate', 0);
  const staleRate = _get(workerData, 'staleRate', 0);
  const invalidRate = _get(workerData, 'invalidRate', 0);

  return (
    <>
      <div className="font-medium text-white text-base">
        <FormattedMessage id="shares" />
      </div>
      <StatsIndicator.Group 
        className="flex -mx-2 my-4"
        selectedItems={visibleChartBars}
        onChange={(items) => setVisibleChartBars(items)}
      >
        <StatsIndicator.Item
          name="validCount"
          size='l'
          className='mx-2'
          status='success'
          isLoading={false}
          title={intl.formatMessage({ id: 'shares.valid' })}
          value={validShares}
          subValue={validRate ? getPercent(validRate) : ''}
        />
        <StatsIndicator.Item
          name="invalidCount"
          size='l'
          className='mx-2'
          status='error'
          isLoading={false}
          title={intl.formatMessage({ id: 'shares.rejected' })}
          value={invalidShares}
          subValue={invalidRate ? getPercent(invalidRate) : ''}
        />
      </StatsIndicator.Group>

      <SharesChart 
        workerName={workerName}
        visibleChartBars={visibleChartBars}
      />
    </>
  );
}

export default WorkerShares;
